
export const validateEmailList = (value) => {
    if (!value) return undefined;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emails = String(value)
        .split(/[,\n\r]+/)
        .map(s => s.trim())
        .filter(Boolean);

    const invalid = emails.filter(e => !emailRegex.test(e));
    return invalid.length ? `Email non valide: ${invalid.join(', ')}` : undefined;
};

// helpers
export const composeValidators =
    (...validators) =>
        (value, allValues, meta) =>
            validators.reduce(
                (error, validator) => error || validator(value, allValues, meta),
                undefined
            );


export const requiredIf = (predicate, msg = 'Campo obbligatorio') => (v, allValues) => {
    if (!predicate(allValues)) return undefined;
    return (v || v === 0) ? undefined : msg;
};


export const required = (msg = 'Campo obbligatorio') => (v) =>
    v || v === 0 ? undefined : msg;

// HOST: accetta FQDN, localhost, IPv4 (semplice), IPv6 tra [] (es. [::1])
const hostRegex = new RegExp(
    '^(' +
    'localhost' +
    '|([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,63}' +        // dominio
    '|(\\d{1,3}(?:\\.\\d{1,3}){3})' +             // IPv4
    '|\\[[A-Fa-f0-9:]+\\]' +                      // IPv6 fra []
    ')$'
);

export const validateHost = (v) => {
    if (!v) return undefined; // usa "required" a parte se vuoi obbligatorio
    const value = String(v).trim();
    if (value.includes(':')) return 'Non inserire la porta nell’host (usa il campo Porta)';
    return hostRegex.test(value) ? undefined : 'Host non valido';
};

// PORTA: intero 1..65535
export const validatePort = (v) => {
    if (v === undefined || v === null || String(v).trim() === '') return undefined; // usa "required" a parte
    const n = Number(String(v).trim());
    if (!Number.isInteger(n)) return 'La porta deve essere un numero intero';
    if (n < 1 || n > 65535) return 'La porta deve essere tra 1 e 65535';
    return undefined;
};

// normalizzatore opzionale per la porta (mantiene solo cifre)
export const normalizePort = (v) => {
    if (v === undefined || v === null) return '';
    return String(v).replace(/[^\d]/g, '');
};
